/**
 * Copyright 2024-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import styled from "styled-components";
import { Table, theme } from "@nordcloud/gnui";
import { ResourcesSummary } from "~/views/plans/PlanCreate/components/PlanCreateWizard/PlanSummary/ResourcesSummary";
import { getActionDisplayName } from "~/views/plans/utils";
import { SelectedPlanEntity } from "../types";
import { ResourceGroupSummary } from "./ResourceGroupsSummary";

export function PlanActionSummary({
  action: planAction,
}: {
  action: SelectedPlanEntity;
}) {
  const { name, actionName, actionType, action } = planAction;
  const displayName = getActionDisplayName(
    name ?? "",
    action?.name || actionName || "",
    actionType
  );

  return (
    <>
      <Table.td>
        <ActionRow>{displayName}</ActionRow>
      </Table.td>
      <Table.td
        css={{
          padding: `${theme.spacing.spacing02}`,
        }}
      >
        <ResourceGroupSummary action={planAction} />
      </Table.td>
      <Table.td
        css={{
          padding: `${theme.spacing.spacing02}`,
        }}
      >
        <ResourcesSummary action={planAction} />
      </Table.td>
    </>
  );
}

const ActionRow = styled.div`
  align-items: left;
  word-break: break-word;
`;
